import { IN_DESIGN_KERNING_VALUE_RANGE, IN_DESIGN_TRACKING_RANGE } from "../enums/indesign";

type Range = { min: number; max: number };

function clampToRange(value: unknown, range: Range): number | undefined {
    // Number("") is 0, which would turn a cleared field into a real value
    if (typeof value === "string" && value.trim() === "") {
        return undefined;
    }

    const numeric = typeof value === "string" ? Number(value) : value;

    if (typeof numeric !== "number" || !Number.isFinite(numeric)) {
        return undefined;
    }

    return Math.min(Math.max(numeric, range.min), range.max);
}

/**
 * InDesign refuses anything wider and leaves the render unchanged, so clamp wherever a value is
 * stored or sent rather than only in the editor, which cannot see values saved before the limit.
 */
export function clampInDesignTracking(value: unknown): number | undefined {
    return clampToRange(value, IN_DESIGN_TRACKING_RANGE);
}

export function clampInDesignKerningValue(value: unknown): number | undefined {
    return clampToRange(value, IN_DESIGN_KERNING_VALUE_RANGE);
}
